module.exports = __webpack_public_path__ + "img/shoucang-yishoucang.d8878e72.png";